import { DIALOG_SIZE, HTML } from "@libs/interfaces/layouts"
import { CSSProperties, useState } from "react"
import ScalableDialog from "../ScalableDialog"
import parseShortcode from "./parseShortcode"

/* Protopia Ecosystem component */
export interface IShortcodeProps {
   content: HTML |string
   className?: string
   style?:CSSProperties
   title?: string
   max_length?: number
   contentEditable?: boolean
   onClick?: (obj: any) => void
   showMore?: boolean // show button for see more
   ["data-testid"]?: string
   ["data-primitive-type"]?: string
}
const Shortcode = ( props: IShortcodeProps ): JSX.Element => {
    const [ isOpen, setIsOpen ] = useState<boolean>( false )

    const onChange = (obj:any) => {        
        //console.log(evt.currentTarget) 
        if(!!props.onClick) {
            props.onClick(obj) 
        }      
    }
    return <div 
        className={ props.className } 
        style={ props.style } 
        title={ props.title || "" }  
        data-text={ props.content }
        data-testid={props["data-testid"]} 
        data-primitive-type={props["data-primitive-type"]}
    > 
        <span onClick={ props.onClick }>
            {
                parseShortcode( 
                    props.content, 
                    props.max_length,
                    "",
                    props.contentEditable,
                    onChange,
                    props.showMore
                )
            } 
        </span>
        {
            !!props.max_length && props.content.length > ( props.max_length || 0 ) && props.showMore
                ?
                <>
                    <div className="btn btn-sm btn-link" onClick={ () => setIsOpen( !isOpen ) }>
                        <i className="fas fa-long-arrow-alt-down"></i>
                    </div>
                    <ScalableDialog
                        mayFullScreen
                        hideClose={false}
                        isOpen={ isOpen }
                        onClose={ () => setIsOpen( !isOpen ) }
                        dialogSize={ DIALOG_SIZE.LITTLE }
                    >
                        <div className="p-5 max-height overflow-y-auto" >
                            <div className="container">
                                { parseShortcode( props.content ) }
                            </div> 
                        </div>
                    </ScalableDialog>
                </>
                :
                ``
        }
    </div>
}
export default Shortcode

export {
    parseShortcode
}

